import { bgType } from '@/types/cms';
import { getCroppedImageUrl } from '@/components/common/CroppedImage';
import { parseJson } from '@/utils/parseJson';

export const getConfigBg = (bgInfo: string) => {
  if (!bgInfo) return '';
  const bgObj = parseJson(bgInfo);
  if (bgObj?.value) {
    if (bgObj?.type === bgType.image) {
      return {
        background: `url('${getCroppedImageUrl(bgObj?.value, {
          devicePixelRatio: 2
        })}') center top/cover no-repeat`
      };
    }
    if (bgObj?.type === bgType.color) {
      return {
        background: `${bgObj?.value}`
      };
    }
  }
};
